import { render, staticRenderFns } from "./UserRank.vue?vue&type=template&id=10196682&scoped=true&"
import script from "./UserRank.vue?vue&type=script&lang=js&"
export * from "./UserRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10196682",
  null
  
)

export default component.exports